import { RichTextWithAssetContainer } from '@r-and-a-shared-ui/common-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { SSO_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export default {
  component: ()=>RichTextWithAssetContainer,
  mapEntryToProps: (entry: SSO_MODELS.RichTextWithAssetContainer) =>
    kontentAiDataMapping.rich_text_with_asset_container(entry),
};
